// extracted by mini-css-extract-plugin
module.exports = {"directComment":"I7afx","text":"I7ah","hidden":"I7b-"};